// This icon file is generated automatically.
var BanCircleOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 200 200", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M100 187.5c-48.44 0-87.5-39.06-87.5-87.5S51.56 12.5 100 12.5s87.5 39.06 87.5 87.5-39.06 87.5-87.5 87.5zm79.38-87.5c0-43.75-35.63-79.38-79.38-79.38S20.62 56.26 20.62 100s35.63 79.38 79.38 79.38 79.38-35.63 79.38-79.38zm-44.7-71.56L57.5 167.19l7.81 4.37L141.56 32.2l-6.87-3.75z" } }] }, "name": "ban-circle", "theme": "outlined" };
export default BanCircleOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/BanCircleOutlined.js
// module id = 2049
// module chunks = 0